import { HttpClient } from '@angular/common/http';
import { HostListener, Injectable } from '@angular/core';
import { BQXConfiguration } from 'bqx-ui-common';
import { envTheme } from './models/env-theme/env-theme';
import { IAppConfig } from './models/shared/app-config.model';
import { Global } from './models/shared/app-global.model';

// Sr No.     Date         WorkItem ID       Modified By             Change/Description
// 01         01/06/2022   4325916           Ritesh Sinha            Created new service class to load enviornmnet configuration
//

/**
 * @class AppConfig
 * @description To initialize configuration attributes
 */
@Injectable()
export class AppConfig {
  static settings: IAppConfig;
  static appGuid: string;
  static loadedAppConfig: boolean;
  static isAppConfigRoute = false;

  /**
   * Creates an instance of AppConfig.
   */
  constructor(private http: HttpClient) { }

  /**
   * @description to load attributes from configuration file
   * @type public method
   * @param
   * @returns
   */
  load() {
    console.log('AppConfig load started.');
    const jsonFile = 'assets/config/config.json';
    return new Promise<void>((resolve, reject) => {
      this.http
        .get(jsonFile)
        .toPromise()
        .then((response: any) => {
          AppConfig.settings = AppConfig.resolveProviderConfig(<IAppConfig>response);
          BQXConfiguration.setConfig = AppConfig.settings.bqxCoreConfig;
          Global.currentTheme = new envTheme(document);
          Global.sessionId = crypto.randomUUID();
          Global.screenWidth = window.innerWidth;
          resolve();
        })
        .then(() => {
          this.loadScripts();
        })
        .catch((response: any) => {
          console.log('AppConfig loading Error: ' + JSON.stringify(response));
          reject(`Could not load file '${jsonFile}': ${JSON.stringify(response)}`);
        });
    });
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    Global.screenWidth = window.innerWidth;
  }

  /**
   * @description overlays the block under authProviders matching the active authProvider onto the base config
   */
  private static resolveProviderConfig(settings: IAppConfig): IAppConfig {
    const overrides = settings.authProviders?.[settings.bqxCoreConfig.authProvider];
    if (!overrides) {
      return settings;
    }

    return {
      ...settings,
      bqxCoreConfig: { ...settings.bqxCoreConfig, ...overrides.bqxCoreConfig }
    };
  }

  private loadScripts() {
    const dynamicScripts = [AppConfig.settings.quantumMetric.scriptUrl.toString()];

    for (let i = 0; i < dynamicScripts.length; i++) {
      const node = document.createElement('script');
      node.src = dynamicScripts[i];
      node.type = 'text/javascript';
      node.async = false;
      document.getElementsByTagName('head')[0].appendChild(node);
    }
  }
}
